// File: /src/App.js

import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { ThemeProvider } from './contexts/ThemeContext';
import { ConfirmDialogProvider } from './contexts/ConfirmDialogContext';
import Header from './components/Header';
import Footer from './components/Footer';
import AppRoutes from './routes/AppRoutes';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import './styles/Layout.css';
import './styles/CustomToastify.css';
import 'react-toastify/dist/ReactToastify.css';

const AppContent = () => {
	const { isAuthenticated } = useAuth();

	return (
		<>
			{isAuthenticated && <Header />}
			<main className="main-content">
				<AppRoutes />
			</main>
			{isAuthenticated && <Footer />}
		</>
	);
};

function App() {
	return (
		<AuthProvider>
			<ThemeProvider>
				<ConfirmDialogProvider>
					<Router>
						<>
							<AppContent />
							<ToastContainer
								position="top-right"
								closeButton
								closeOnClick={false}
							/>
						</>
					</Router>
				</ConfirmDialogProvider>
			</ThemeProvider>
		</AuthProvider>
	);
}

export default App;
